<div @show class="body" [formGroup]="formGroup">

    <div class="header" *ngIf="rootName">

        <span class="fiv-sqo file-icon fiv-icon-folder"></span>
        <div class="text">

            {{rootName}}

        </div>

    </div>

    <div class="hint">
        <mat-icon class="icon">
            info
        </mat-icon>
        <div class="text-wrapper">
            Wählen Sie eine Sammlung von Dateien aus, welche Sie mit Abschluss der Transaktion herunterladen möchten.
        </div>
    </div>

    <ng-container *ngFor="let file of nextcloudFolder">

        <div class="file-wrapper" (click)="toggleSelection(file)">

            <mat-checkbox [checked]="downloadSelectionMapReadOnly[file.uuid]" (click)="$event.preventDefault()"></mat-checkbox>
            <app-nextcloud-file-preview class="preview" [file]="file"></app-nextcloud-file-preview>
            <div class="options">

                <button mat-icon-button (click)="previewFile($event, file)">
                    <mat-icon>search</mat-icon>
                </button>

            </div>

        </div>

    </ng-container>

</div>